export enum CountryIsoNumber {
  GreatBritain = 826,
  Ireland = 372,
}
